export enum ConfirmDialogType {
  Ok,
  LeaveStay,
  YesNo,
  LogoutHome
}

export enum ConfirmDialogResult {
  Ok,
  Leave,
  Stay,
  Yes,
  No,
  Logout,
  Home
}
